import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import MRLogin from "@/pages/MRLogin";
import AdminLogin from "@/pages/AdminLogin";
import MRDashboard from "@/pages/MRDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import SubmissionDetail from "@/pages/SubmissionDetail";
import StandeeStudio from "@/pages/StandeeStudio";
import LamaStudio from "@/pages/LamaStudio";
import { Loader2 } from "lucide-react";

function Protected({ role, children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F8F9FA]">
        <Loader2 className="h-8 w-8 animate-spin text-[#0B5351]" />
      </div>
    );
  }
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/"} replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/mr"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* MR login is the front door; admin reaches its own login by URL only. */}
            <Route path="/" element={<MRLogin />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/mr" element={<Protected role="mr"><MRDashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/admin/submissions/:id" element={<Protected role="admin"><SubmissionDetail /></Protected>} />
            <Route path="/admin/submissions/:id/standee" element={<Protected role="admin"><StandeeStudio /></Protected>} />
            <Route path="/admin/submissions/:id/lama-studio" element={<Protected role="admin"><LamaStudio /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
